import { render, staticRenderFns } from "./ConfirmProject.vue?vue&type=template&id=4350c6ae&scoped=true"
import script from "./ConfirmProject.vue?vue&type=script&lang=js"
export * from "./ConfirmProject.vue?vue&type=script&lang=js"
import style0 from "./ConfirmProject.vue?vue&type=style&index=0&id=4350c6ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4350c6ae",
  null
  
)

export default component.exports